export default "__VITE_ASSET__DJHTI5xu__"